import { render, staticRenderFns } from "./AuthorHeader.vue?vue&type=template&id=5b43edc0&"
import script from "./AuthorHeader.vue?vue&type=script&lang=js&"
export * from "./AuthorHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports